import Header from "./Header";
import Footer from "./Footer";

function Facilities() {
  return (
    <>
      <Header />
      <section id="facilities" className=" page p-0 m-0 gap-0">
        <div>
          {/* Header */}
          <div className="bg-light py-0 text-center">
            <h1
              className="contact-bg pt-0 text-light  text-uppercase  text-center  fw-bold col-md-12 col-lg-12 col-sm-12 "
              style={{
                fontSize: "3rem",
                letterSpacing: "3.5px",
                borderBottom: "7px solid gold",
                borderRadius: "5px",
                display: "inline-block",
                paddingBottom: "5px",
              }}
            >
              OUR FACILITIES
            </h1>
          </div>

          {/* Main Section / part 1*/}
          <div className="container my-5">
            <div className="row align-items-center g-4">
              {/* Left Content */}
              <div className="col-lg-6 p-0 m-0 ">
                <h2 className="fw-bold text-primary-emphasis ">
                  Our State of the Art Facilities for Accurate Diagnostics and
                  Patient Comfort
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>

                <p className="text-primary-emphasis">
                  Our lab is equipped with modern diagnostic machines that
                  ensure fast, accurate, and reliable test results. We provide a
                  wide range of diagnostic services, including blood tests,
                  imaging, and specialized screenings, all performed with the
                  latest technology. Our facilities are designed to prioritize
                  patient comfort and safety at every step of the diagnostic
                  process. We have created a welcoming and supportive
                  environment to help ease any anxiety associated with medical
                  testing. Our staff is trained to provide compassionate care,
                  ensuring that every patient feels valued and cared for during
                  their visit. At Rapid Lab Diagnostics, we are committed to
                  delivering exceptional diagnostic services while maintaining a
                  focus on patient well-being and comfort.
                </p>

                <p className="text-primary-emphasis">
                  Our laboratory is equipped with the latest technology and
                  staffed by highly trained professionals who prioritize your
                  comfort and well-being. We understand that medical testing can
                  be stressful, which is why we have created a welcoming
                  environment to make your experience as pleasant as possible.
                </p>
              </div>
              {/* Right Images */}
              <div className="col-lg-6 text-center">
                <img
                  src="images/assets/rapidLab-enterance.jpeg"
                  alt="MRI"
                  loading="lazy"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "450px",
                    objectFit: "cover",
                    width: "100%",
                  }}
                />

                {/* Thumbnails */}
                <div className="d-flex justify-content-center gap-2">
                  <img
                    loading="lazy"
                    src="images/assets/x-ray-pic.jpeg"
                    alt="lab1"
                    className="rounded"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    loading="lazy"
                    src="https://images.unsplash.com/photo-1579154204601-01588f351e67"
                    alt="lab2"
                    className="rounded"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    loading="lazy"
                    src="images/assets/facility-1.jpeg"
                    alt="lab3"
                    className="rounded"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
            {/* put  CARD HERE */}
            <div
              className="card mb-3 mt-3 pt-md-2 shadow-sm rounded"
              style={{ maxWidth: "600px", borderTop: "4px solid #FFD700" }}
            >
              <div className="row g-0">
                <div className="col-md-12">
                  <div className="card-body">
                    <h5 className="card-title text-primary-emphasis fw-semibold">
                      How Our Facilities Ensure Accurate Diagnostics and Patient
                      Comfort
                    </h5>
                    <p className="card-text col-12">
                      Our state-of-the-art facilities are designed to provide
                      accurate diagnostics while prioritizing patient comfort.
                      We utilize advanced technology and equipment to ensure
                      precise results and a comfortable experience for all our
                      patients. Our lab is equipped with modern diagnostic
                      machines that ensure fast, accurate, and reliable test
                      results. We provide a wide range of diagnostic services,
                      including blood tests, urine tests, and other specialized
                      examinations.
                    </p>
                    <p className="card-text col-12"></p>
                  </div>
                </div>
              </div>
            </div>

            {/* part 2 */}
            <div className="row align-items-center g-4 py-5 mt-5">
              {/* Left Content */}
              <div className="col-lg-6">
                <h2 className="fw-bold text-primary-emphasis ">
                  Reason For Choosing Rapid Lab Diagnostics for Your Diagnostic
                  Needs
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>

                <p className="text-primary-emphasis">
                  <ul className="p-0 m-0 ">
                    <li className="list-unstyled  pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Our facilities use advanced technology and skilled
                        professionals to ensure your comfort, providing a
                        welcoming and stress-free testing experience.
                      </span>
                    </li>

                    <li className="list-unstyled  pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Our facilitys are designed to provide a comfortable and
                        welcoming environment for patients, with amenities such
                        as comfortable seating, private testing rooms, and a
                        friendly staff to assist you throughout your visit.
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Our facilities are designed to provide a comfortable and
                        welcoming environment for patients, with amenities such
                        as comfortable seating, private testing rooms, and a
                        friendly staff to assist you throughout your visit.
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Our facilities are designed to provide a comfortable and
                        welcoming environment for patients, with amenities such
                        as comfortable seating, private testing rooms, and a
                        friendly staff to assist you throughout your visit.
                      </span>
                    </li>
                  </ul>
                </p>

                <p className="text-primary-emphasis">
                  At Rapid Lab Diagnostics, we are committed to providing
                  accurate diagnostics while ensuring that our patients feel
                  comfortable and cared for throughout their testing experience.
                </p>
              </div>

              {/* Right Images */}
              <div className="col-lg-6 text-center">
                <img
                  loading="lazy"
                  src="images/assets/facility-2.jpeg"
                  alt="rapidLabEnterance"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "500px",
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </div>
            {/* Reviews */}

            <div className="container text-center py-5 bg-muted    ">
              <div className="row align-items-center g-4 py-5 mt-5">
                <div className="col-lg-6 text-center">
                  <img
                    loading="lazy"
                    src="images/assets/rapidLab-equipment.jpeg"
                    alt="rapidLabEnterance"
                    className="img-fluid rounded mb-3"
                    style={{
                      maxHeight: "500px",
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </div>
                <div className="col-lg-6">
                  <h2 className="fw-bold text-primary-emphasis text-start ">
                    Choose Rapid Lab Diagnostics for Your Diagnostic Needs and
                    Experience the Difference in Quality and Comfort
                  </h2>

                  <div
                    className="my-3 "
                    style={{
                      width: "200px",
                      height: "5px",
                      backgroundColor: "gold",
                      borderRadius: "5px",
                    }}
                  ></div>

                  <p className="text-primary-emphasis text-start">
                    At Rapid Lab Diagnostics, we are committed to more than just
                    delivering accurate test results — we strive to provide a
                    testing experience that is as comfortable and reassuring as
                    it is precise. We understand that medical testing can
                    sometimes be stressful, which is why our team prioritizes
                    your comfort and well-being every step of the way. Our
                    state-of-the-art facilities are equipped with the latest
                    diagnostic technology, allowing us to perform a wide range
                    of tests efficiently and reliably. Combined with the
                    expertise of our highly trained and compassionate staff, we
                    ensure that every patient receives care in an environment
                    that is both professional and welcoming. From routine blood
                    work to specialized diagnostics, Rapid Lab Diagnostics
                    offers a comprehensive suite of services designed to meet
                    your healthcare needs with speed, accuracy, and attention to
                    detail. We take pride in not only providing results you can
                    trust but also creating a positive experience that eases any
                    concerns you may have. Choose Rapid Lab Diagnostics for your
                    diagnostic needs and discover the difference that quality,
                    precision, and compassionate care can make. Your health,
                    comfort, and confidence are our top priorities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Facilities;
